module.exports = __webpack_public_path__ + "img/thumb_13.b734bb7e.jpg";